export enum LaunchDarklyKey {
    BANNERPOC = '569017-find-care-poc'
}